<app-breadcrumb
  [title]="'Потребители'"
  [active_item]="'Потребители'">
</app-breadcrumb>

<ng-container *ngIf="isLoaded; else loadingTemplate">
  <div class="card card-reset">
    <!-- Card header -->
    <div class="card-header">
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row justify-content-between">
            <div>

            </div>
            <div class="d-flex flex-row gap-3">
              <button
                type="button"
                class="btn btn-success btn-sm"
                (click)="onUserCreation()"
              >
                <i class="fa fa-plus"></i> Добави потребител
              </button>
              <button
                type="button"
                class="btn btn-light btn-sm"
                (click)="toggleSearchFilters()"
              >
                <i class="fa fa-filter"></i> {{searchFiltersToggled ? 'Скрий филтрите': 'Покажи филтрите'}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="searchFiltersToggled" class="row mt-3">
        <div class="col">
          <app-users-filter-form
            [usersList]="users"
            [initialTitle]="searchQuery"
            (inputChanged)="onFilterUsersList($event)"
          ></app-users-filter-form>
        </div>
      </div>
    </div>

    <!-- Card body -->
    <div class="card-body">
      <ng-container *ngIf="!!searchQuery">
        <ng-container *ngTemplateOutlet="filtersResultInfo"></ng-container>
      </ng-container>
      <table class="table table-sm table-reset table-hover">
        <thead>
          <tr>
            <th scope="col">Име</th>
            <th scope="col">Фамилия</th>
            <th scope="col">Потребителско Име</th>
            <th scope="col">Организация</th>
            <th scope="col">Вик:Ремонта Група</th>
            <th scope="col">Роля</th>
            <th scope="edit-action-col">Редакция</th>
            <th scope="edit-action-col">Изтриване</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of filteredUsers" [ngClass]="!isSelected(user)?'':'selected-cell'" (click)="onUserSelected(user)">
            <td>{{user.firstName}}</td>
            <td>{{user.lastName}}</td>
            <td>{{user.email}}</td>
            <td>{{user.organization}}</td>
            <td>{{GetWorkingGroup(user)}}</td>
            <td>{{user.role}}</td>
            <td class="edit-action-col">
              <button
                class="grid-btn btn btn-warning btn-sm"
                ngbTooltip="Натиснете тук за да редактирате този потребител."
                placement="top"
                (click)="onUserEditBtnClicked(user)">
                <i class="fa fa-pencil"></i>
              </button>
            </td>
            <td class="edit-action-col">
              <button
                  class="grid-btn btn btn-danger btn-sm"
                  ngbTooltip="Натиснете тук за да изтриете този потребител."
                  placement="top"
                  (click)="onUserDeleteBtnClicked(user)">
                  <i class="fa fa-trash-o"></i>
                </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</ng-container>

<ng-template #loadingTemplate>
  <app-loader text="Зареждане на списъка с потребители..."></app-loader>
</ng-template>

<!--Applied filters Info-->
<ng-template #filtersResultInfo>
  <div role="alert" class="alert alert-info outline d-flex flex-row justify-content-between">
    <p>
      <i class="fa fa-filter"></i> <span>Показани са <span class="fw-bold">само</span> тези резултитати, които отговарят на <span class="fw-bold">избраните филтри</span>.</span>
    </p>
    <button class="btn btn-info btn-sm" (click)="onClearFiltersClicked()">
      Изчисти филтрите
    </button>
  </div>
</ng-template>
